import '@mdi/font/css/materialdesignicons.css';
import { es } from 'vuetify/locale';
import { createVuetify, type ThemeDefinition } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import 'vuetify/styles';

// Farm color palette - keep in sync with FARM_COLORS in composables/useCowHelpers.ts
const lightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    background: '#FFFFFF',
    surface: '#FFFFFF',
    primary: '#28363d',
    secondary: '#99aead',
    error: '#e11717',
    info: '#2196F3',
    success: '#658b6f',
    warning: '#FB8C00',
    'color-0': '#c19d43',
    'color-1': '#be6043',
    'color-2': '#658b6f',
    'color-3': '#99aead',
    'color-4': '#28363d',
    'color-5': '#dee1dd',
    'color-leche': '#B39DDB',
    'light-gray': '#eeeeee'
  }
};

export default createVuetify({
  components,
  directives,
  locale: {
    locale: 'es',
    messages: { es }
  },
  icons: {
    defaultSet: 'mdi'
  },
  theme: {
    defaultTheme: 'lightTheme',
    themes: {
      lightTheme
    }
  }
});
